import config from '../config.js'
import commonRoutes from './commonRoutes.js';
import pmWarrantyRoutes from './pm-warranty/pm-warranty-routes';
import realEstateRoutes from './real-estate-routes.js';

let routesConfiguration = {};
let { createAppointmentClientRoot, createSaleClientRoot, createOrderClientRoot } = config;

routesConfiguration = {
    ROOT : createAppointmentClientRoot + "/" ,
    // HANDYMAN ROUTES
    SELECT_ISSUE: createAppointmentClientRoot + '/select-issue',
    HVAC: createAppointmentClientRoot + '/hvac',
    SELECT_APPLIANCES_ISSUE: createAppointmentClientRoot + '/select-appliances-issue',
    SAMSUNG_APPLIANCES: createAppointmentClientRoot + '/samsung-appliances',
    LG_APPLIANCES: createAppointmentClientRoot + '/lg-appliances',
    SELECT_PAINTING_ISSUE: createAppointmentClientRoot + '/select-painting-issue',
    HOME_APPLIANCES: createAppointmentClientRoot + '/home-appliances',
    PLUMBING: createAppointmentClientRoot + '/plumbing',
    GARAGE_DOORS: createAppointmentClientRoot + '/garage-doors',
    SMART_HOME: createAppointmentClientRoot + '/smart-home',
    TV_MOUNTING: createAppointmentClientRoot + '/tv-mounting',
    PHONE_REPAIR: createAppointmentClientRoot + '/phone-repair',
    HOME_THEATER: createAppointmentClientRoot + '/home-theater',
    REKEY_SERVICES: createAppointmentClientRoot + '/rekey-services',
    WIFI_CONNECTION: createAppointmentClientRoot + '/wifi-connection',
    //GENERAL
    ZIP_CODE : createAppointmentClientRoot + '/zip-code',
    UNSUPPORTED_ZIP_CODE : createAppointmentClientRoot + '/unsupported-zip-code',
    SELECT_TIME : createAppointmentClientRoot + "/select-time",
    SELECT_FILES : createAppointmentClientRoot + "/select-files",
    SELECT_ADDRESS:createAppointmentClientRoot + "/enter-user-address",
    ENTER_USER_DETAILS : createAppointmentClientRoot + "/enter-user-details",
    UPSELL_MEMBERSHIP : createAppointmentClientRoot + "/upsell-membership",
    THANK_YOU : createAppointmentClientRoot + "/thank-you",
    CONTINUE_APPOINTMENT: createAppointmentClientRoot + "/continue-appointment",
    CONFIRM_APPOINTMENT: createAppointmentClientRoot + "/confirm-appointment",
    CONFIRM_APPOINTMENT_V2: createAppointmentClientRoot + "/appointment-confirmation",
    CONFIRM_PREPAYMENT: createAppointmentClientRoot + "/payment-method",
    PAYMENT: createAppointmentClientRoot + "/payment",
    ASSIGN_APPOINTMENT: createAppointmentClientRoot + "/assign-appointment",

    THUMBTACK: createAppointmentClientRoot + "/thumbtack",
    WORK_ORDER: createAppointmentClientRoot + "/work-order",
    WORK_ORDER_THANKYOU: createAppointmentClientRoot + "/work-order-thankyou",
    // create sale
    CS_ROOT: createSaleClientRoot + '/',
    CS_APPLIANCES_SELECTION: createSaleClientRoot + "/appliance-protection",
    CS_MEMBERSHIP: createSaleClientRoot + "/membership",
    CS_MEMBERSHIP_DURATION: createSaleClientRoot + "/membership-duration",
    CS_ZIP_CODE : createSaleClientRoot + '/zip-code',
    CS_SELECT_ADDRESS: createSaleClientRoot + "/address",
    CS_ENTER_USER_DETAILS : createSaleClientRoot + "/personal-details",
    CS_PAYMENT : createSaleClientRoot +  "/confirm-details",
    //Real Estate
    ...realEstateRoutes,
    ...commonRoutes,
    //Create Appointment2
    CO_ROOT: createOrderClientRoot + '/',
    CO_DEVICE: createOrderClientRoot + '/device',
    CO_INITIAL_DETAILS: createOrderClientRoot + '/initial-details',
    CO_DEVICE_ISSUE: createOrderClientRoot + '/issue',
    CO_THUMBTACK: createOrderClientRoot + "/thumbtack",
    CO_USER_DETAILS: createOrderClientRoot + '/details',
    ...pmWarrantyRoutes
};

export default routesConfiguration;
